// import { saveAs } from 'file-saver';
import uniq from 'lodash.uniq';
import * as React from 'react';
import * as Boots from 'react-bootstrap';
import BottomScrollListener from 'react-bottom-scroll-listener';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';
import moment from 'moment';
import * as apx from '../api/apxService';
import { url } from './general/generalUtil';
import { redirectToUrl } from '../general/generalUtil';
import { CustomTooltip } from './general/CustomTooltip';
import Languages from './general/Languages';

export class ReportList extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      reports: [],
      total: 0,
      loadingPdf: false,
      loadingReports: false,
      index: null,
      limit: null,
      offset: null,
    };
  }

  handleScroll = async () => {
    if (this.state.total > this.state.offset) {
      const reports = await apx.get(apx.service.report, `?user_id=${this.state.user.id}` +
        `&sort(-creation_timestamp)&limit(${this.state.limit},${this.state.offset})`);
      let list = await this.addGroupNamesToReports(reports);
      list = this.state.reports.concat(list);
      this.setState({ reports: list, total: reports.page.total, loadingReports: false, limit: 20, offset: this.state.offset + 20 });
    }
  }

  addGroupNamesToReports = async (reports: any) => {
    const list = reports.data;
    const groupIds = list.map((report: any) => report.group_id);
    const uniqueGroupIds = uniq(groupIds);
    if (uniqueGroupIds.length !== 0) {
      const groups = await apx.get(apx.service.groups, `?in(id,${uniqueGroupIds.join()})`);
      for (const item of list) {
        for (const group of groups.data) {
          if (item.group_id === group.id) {
            item.group = group.name;
          }
        }
      }
    }
    return list;
  }

  async componentDidMount() {
    moment.locale(this.props.language);
    try {
      const { user } = this.props;
      this.setState({ user, loadingReports: true });
      const reports = await apx.get(apx.service.report, `?user_id=${user.id}&out(trigger,MANUAL)&sort(-creation_timestamp)`);
      const list = await this.addGroupNamesToReports(reports);
      this.setState({ reports: list, total: reports.page.total, loadingReports: false, limit: 20, offset: 20 });
    } catch (e) {
      const error:any = await e;
      if (error.code === 104 || error.code === 108) {
        redirectToUrl(`${url.pages}/login/?redirect=${encodeURIComponent(`${url.pages}/myreports/`)}`);
      } else {
        Alert.error(this.props.intl.formatMessage({ id: 'error' }), { position: 'bottom-left', effect: 'slide' });
      }
    }
  }

  handleDownload = async (event: any) => {
    if (event.target.dataset.status === 'COMPLETE') {
      this.setState({ loadingPdf: true, index: event.target.dataset.index });
      event.persist();
      event.preventDefault();
      event.stopPropagation();
      const download = await apx.get(apx.service.report, `${event.target.dataset.id}/pdf/${this.props.language}`);
      if (download) {
        saveAs(download, `FIB_report${moment(Number(event.target.dataset.timestamp)).format('DD MMM YYYY')}.pdf`);
        this.setState({ loadingPdf: false, index: null });
      }
    }
  }

  handeLogout = async () => {
    await apx.post(apx.service.logout);
  }

  handleLink = (event: any) => {
    if (this.state.loadingPdf) {
      event.preventDefault();
    }
  }

  public render() {
    const menuItems = [];
    const { loadingPdf } = this.state;
    let index = 0;
    for (const report of this.state.reports) {
      const startTimestamp = moment(report.content.start_timestamp);
      const endTimestamp = moment(report.content.end_timestamp);
      const days = endTimestamp.diff(startTimestamp, 'days');
      menuItems.push(
        <Link to={`/report/${report.id}`} key={report.id} onClick={this.handleLink} className={loadingPdf ? 'disabled' : ''}>
          <Boots.ListGroupItem disabled={loadingPdf}>
            <div className="row">
              <div className="col-sm-2 col-xs-12 vcenter">
                <div className="item reason">
                  <FormattedMessage id={report.trigger} defaultMessage="Prescription expired" />
                </div>
              </div>
              <div className="col-sm-3 col-xs-12 vcenter">
                <div className="mobile-header"><FormattedMessage id="period" defaultMessage="PERIOD" /></div>
                <div className="item">
                  <span className="days">
                    { days } { days === 1 ? <FormattedMessage id="day" defaultMessage="day" /> : <FormattedMessage id="days" defaultMessage="days" /> }
                  </span>
                  <span className="block">{ startTimestamp.format('DD MMM YYYY') } &rarr; { endTimestamp.format('DD MMM YYYY') }</span>
                </div>
              </div>
              <div className="col-sm-2 col-xs-12 vcenter">
                <div className="mobile-header"><FormattedMessage id="status" defaultMessage="STATUS" /></div>
                {
                  report.status === 'COMPLETE' ? (
                    <div className="item"><span className="label label-green">
                      <FormattedMessage id="complete" defaultMessage="COMPLETE" /></span> &nbsp;
                    <CustomTooltip color="color-green" message={this.props.intl.formatMessage({ id: 'infoComplete' })} />
                    </div>
                  ) : (
                    <div className="item"><span className="label">
                      <FormattedMessage id="incomplete" defaultMessage="INCOMPLETE" /></span> &nbsp;
                    <CustomTooltip message={this.props.intl.formatMessage({ id: 'infoIncomplete' })} />
                    </div>
                  )
                }
              </div>
              <div className="col-sm-2 col-xs-12 vcenter">
                <div className="mobile-header"><FormattedMessage id="group" defaultMessage="GROUP" /></div>
                <div className="item">{ report.group ? report.group : 'N/A' }</div>
              </div>
              <div className="col-sm-2 col-xs-12 vcenter">
                <div className="mobile-header"><FormattedMessage id="date" defaultMessage="DATE" /></div>
                <div className="item">{ moment(report.creation_timestamp).format('YYYY-MM-DD') } &nbsp;
                  <span className="block">{ moment(report.creation_timestamp).format('LT') }</span></div>
              </div>
              <div className="col-sm-1 col-xs-12 vcenter">
                <div className="item">
                  {
                    this.state.loadingPdf && Number(this.state.index) === index ?
                      <i className="fa fa-spinner fa-pulse fa-fw loader-green" /> : (
                        <button
                          type="button"
                          className="btn btn-xs btn-small-green fa fa-download"
                          disabled={report.status !== 'COMPLETE'}
                          data-id={report.id}
                          data-index={index}
                          data-status={report.status}
                          data-timestamp={report.creation_timestamp}
                          onClick={this.handleDownload}
                        />
                      )
                  }
                </div>
              </div>
            </div>
          </Boots.ListGroupItem>
        </Link>
      );
      index += 1;
    }

    return (
      <div id="wrapper">
        <BottomScrollListener onBottom={this.handleScroll} />
        {
          this.state.total === 0 && this.state.loadingReports === false ? (
            <div className="container">
              <div className="title">
                <FormattedMessage id="myReports" defaultMessage="My Reports" />&nbsp;
                {
                  this.state.loadingReports ?
                    <small>(<i className="fa fa-spinner fa-pulse fa-fw" />)</small> :
                    <small>({ this.state.total })</small>
                }
              </div>
              <FormattedMessage id="noReports" defaultMessage="No reports available at this moment ..." />
            </div>
          ) : (
            <div className="container">
              <div className="title">
                <FormattedMessage id="myReports" defaultMessage="My Reports" />&nbsp;
                {
                  this.state.loadingReports ?
                    <small>(<i className="fa fa-spinner fa-pulse fa-fw" />)</small> :
                    <small>({ this.state.total })</small>
                }
                <div className="pull-right">
                  <Languages language={this.props.language} onSelect={({ key }: any) => { this.props.changeLanguage(key); }} />
                </div>
              </div>
              <Boots.ListGroup>
                <div className="header">
                  <Boots.ListGroupItem className="header">
                    <div className="row">
                      <div className="col-sm-2 item"><FormattedMessage id="reason" defaultMessage="REASON" /></div>
                      <div className="col-sm-3 item"><FormattedMessage id="period" defaultMessage="PERIOD" /></div>
                      <div className="col-sm-2 item"><FormattedMessage id="status" defaultMessage="STATUS" /></div>
                      <div className="col-sm-2 item"><FormattedMessage id="group" defaultMessage="GROUP" /></div>
                      <div className="col-sm-2 item"><FormattedMessage id="created" defaultMessage="CREATED" /></div>
                      <div className="col-sm-1 item" />
                    </div>
                  </Boots.ListGroupItem>
                </div>
                <div className="content">
                  { menuItems }
                </div>
              </Boots.ListGroup>
            </div>
          )
        }
      </div>
    );
  }
}

export default injectIntl(ReportList);
